module.exports = __webpack_public_path__ + "img/non_inventory.ed565a03.png";